import { CompanyEffects } from './company.effects';
import { CompaniesEffects } from './companies.effects';
import { CompaniesUIEffects } from './companies.ui.effects';

export const Effects = [
    CompanyEffects,
    CompaniesEffects,
    CompaniesUIEffects
];
